import { Card, CardContent, Typography, Stack, Link } from '@mui/material';

import { TruncatedTypography } from '../typography';
import { Iconify } from '../iconify';
import { StatusTag } from '../status-tag';
import { useDialog } from '@app/hooks';
import { ViewHospitalReport } from '@app/modules/add-leave-employee';
import { CustomAvatar } from '../custom-avatar';

interface Props {
  title?: string;
  status: string;
  days?: string;
  name?: string;
  period?: string;
  document?: string;
  date?: string;
  description: string;
}

const LeaveDetailCard = ({
  title,
  days,
  status,
  name,
  period,
  document,
  date,
  description,
}: Props) => {
  const viewReport = useDialog();
  return (
    <Card sx={{ width: '465px', mb: 2, borderRadius: '5px' }}>
      <CardContent>
        <Stack gap={2}>
          <Stack direction={'row'} justifyContent={'space-between'} flexWrap={'wrap'}>
            <Stack fontWeight={700}>{title}</Stack>
            <Stack fontWeight={600}>{days}</Stack>
          </Stack>
          <Stack direction={'row'} justifyContent={'space-between'}>
            <Stack>{period}</Stack>
            <StatusTag status={status} />
          </Stack>
          <Stack>
            <TruncatedTypography
              sx={{ fontSize: 20 }}
              lines={4}
              height={90}
              variant="body2"
              text={description}
            />
          </Stack>
          <Stack direction={'row'} spacing={1}>
            <Iconify icon="fluent:document-24-regular" onClick={viewReport.show} />
            <Typography fontSize={14}>
              <Link color={'black'} onClick={viewReport.show}>
                {document}
              </Link>
            </Typography>
          </Stack>
          <Stack direction={'row'} justifyContent={'space-between'} flexWrap={'wrap'}>
            <Stack direction={'row'} sx={{ fontStyle: 'italic' }}>
              <Typography fontWeight={600} fontSize={14}>
                Applied on:
              </Typography>
              <Typography fontSize={14}> {date}</Typography>
            </Stack>
            <Stack direction={'row'} sx={{ fontSize: 14, fontStyle: 'italic' }} flexWrap={'wrap'}>
              <Typography sx={{ fontSize: 14, fontStyle: 'italic', fontWeight: 600 }}>
                {status} by:
              </Typography>
              <CustomAvatar
                name={name}
                color="info"
                sx={{ width: 25, height: 25, fontSize: 10, mr: 0.5, ml: 0.5 }}
              />
              {name}
            </Stack>
          </Stack>
        </Stack>
      </CardContent>
      {viewReport.visible && <ViewHospitalReport open onClose={viewReport.hide} />}
    </Card>
  );
};

export { LeaveDetailCard };
